import { Box, FormControl, InputLabel, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import SelectDateRangeRetail from 'src/components/Retail/SelectDateRangeRetail';
import { useAppSelector } from 'src/app/hooks';
import { useLocation } from 'react-router';
import DateRangeLabel from 'src/layouts/SidebarLayout/components/DateRangeLabel';

const CustomBox = styled(Box)(
  ({ theme }) => `
    // width: calc(100vw - ${theme.sidebar.width} - ${theme.spacing(10)});
    margin: ${theme.spacing(2, 0)};
    // position: absolute;
`
);

const FilterBox = styled(Box)(
  () => `
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`
);

function BottomHeader() {
  const { pathname } = useLocation();
  const title = pathname.split('/')[2];
  const comparisonDateRangeFormatted = useAppSelector(
    (state) => state.onmComparison.dateRangeFormatted
  );
  const isComparation = useAppSelector(
    (state) => state.onmComparison.isComparation
  );

  return (
    <CustomBox>
      <FilterBox sx={{ gap: 1 }}>
        <FormControl size="small" sx={{ width: 135 }}>
          {isComparation ? <InputLabel id="date-range-label">Period 1</InputLabel> : null}
          <SelectDateRangeRetail
            selectProps={{
              ...(isComparation
                ? { labelId: 'date-range-label', label: 'Period 1' }
                : {}),
              sx: { borderRadius: '16px' }
            }}
          />
        </FormControl>
        {isComparation ? (
          <>
            <Typography variant="caption" fontWeight={600}>
              vs
            </Typography>
            <FormControl size="small" sx={{ width: 135 }}>
              <InputLabel id="comparison-date-range-label">Period 2</InputLabel>
              <SelectDateRangeRetail
                comparison="onm"
                selectProps={{
                  labelId: 'comparison-date-range-label',
                  label: 'Period 2',
                  sx: { borderRadius: '16px' }
                }}
              />
            </FormControl>
          </>
        ) : null}
      </FilterBox>
      <DateRangeLabel
        label={`Viewing ${title} within`}
        secondDateRange={
          isComparation ? comparisonDateRangeFormatted : undefined
        }
      />
    </CustomBox>
  );
}

export default BottomHeader;
